"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBaseClient = void 0;
const ApiResponse_1 = require("./model/ApiResponse");
const HttpClient_1 = require("./util/HttpClient");
const ValidatedHttpClient_1 = require("./util/ValidatedHttpClient");
const trace_1 = require("./util/trace");
function makeBaseClient(fetch) {
    const client = (0, ValidatedHttpClient_1.makeValidatedHttpClient)((0, HttpClient_1.makeFetchClient)(fetch), [
        (0, HttpClient_1.jsonClient)(),
        (0, HttpClient_1.traceClient)(trace_1.trace),
    ]);
    return async (req, validateResult, validateRequest) => {
        const response = await client(req, (0, ApiResponse_1.validateApiResponse)(validateResult), validateRequest);
        return response.body;
    };
}
exports.makeBaseClient = makeBaseClient;
//# sourceMappingURL=ApiHttpClient.js.map